import Loadable from 'react-loadable';

export const AnnouncementStepsLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "announcement-step" */ './index'),
  loading: () => null,
});
